import {
  fetchWorkshopHome,
  fetchWorkshopType,
  fetchWorkshopCategory,
  fetchWorkshopProduct,
} from '../util/api';

/**
 * The Workshop (trailer-accessories hub) redux duck.
 * Self-contained: home grid, type page, product detail.
 */

// ================ Action types ================ //
export const WORKSHOP_HOME_REQUEST = 'app/workshop/HOME_REQUEST';
export const WORKSHOP_HOME_SUCCESS = 'app/workshop/HOME_SUCCESS';
export const WORKSHOP_HOME_ERROR = 'app/workshop/HOME_ERROR';

export const WORKSHOP_TYPE_REQUEST = 'app/workshop/TYPE_REQUEST';
export const WORKSHOP_TYPE_SUCCESS = 'app/workshop/TYPE_SUCCESS';
export const WORKSHOP_TYPE_ERROR = 'app/workshop/TYPE_ERROR';

export const WORKSHOP_CATEGORY_REQUEST = 'app/workshop/CATEGORY_REQUEST';
export const WORKSHOP_CATEGORY_SUCCESS = 'app/workshop/CATEGORY_SUCCESS';
export const WORKSHOP_CATEGORY_ERROR = 'app/workshop/CATEGORY_ERROR';

export const WORKSHOP_PRODUCT_REQUEST = 'app/workshop/PRODUCT_REQUEST';
export const WORKSHOP_PRODUCT_SUCCESS = 'app/workshop/PRODUCT_SUCCESS';
export const WORKSHOP_PRODUCT_ERROR = 'app/workshop/PRODUCT_ERROR';

// ================ Reducer ================ //
const initialState = {
  // home
  homeInProgress: false,
  homeError: null,
  types: [],
  categories: [],
  goals: [],
  featured: [],
  // type page
  typeInProgress: false,
  typeError: null,
  currentType: null,
  typeAccessories: [],
  // category / gear-department page
  categoryInProgress: false,
  categoryError: null,
  currentCategory: null,
  categoryAccessories: [],
  // product page
  productInProgress: false,
  productError: null,
  currentProduct: null,
  relatedProducts: [],
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case WORKSHOP_HOME_REQUEST:
      return { ...state, homeInProgress: true, homeError: null };
    case WORKSHOP_HOME_SUCCESS:
      return {
        ...state,
        homeInProgress: false,
        types: payload.types || [],
        categories: payload.categories || [],
        goals: payload.goals || [],
        featured: payload.featured || [],
      };
    case WORKSHOP_HOME_ERROR:
      return { ...state, homeInProgress: false, homeError: payload };

    case WORKSHOP_TYPE_REQUEST:
      return { ...state, typeInProgress: true, typeError: null, currentType: null, typeAccessories: [] };
    case WORKSHOP_TYPE_SUCCESS:
      return {
        ...state,
        typeInProgress: false,
        currentType: payload.type || null,
        typeAccessories: payload.accessories || [],
      };
    case WORKSHOP_TYPE_ERROR:
      return { ...state, typeInProgress: false, typeError: payload };

    case WORKSHOP_CATEGORY_REQUEST:
      return { ...state, categoryInProgress: true, categoryError: null, currentCategory: null, categoryAccessories: [] };
    case WORKSHOP_CATEGORY_SUCCESS:
      return {
        ...state,
        categoryInProgress: false,
        currentCategory: payload.category || null,
        categoryAccessories: payload.accessories || [],
      };
    case WORKSHOP_CATEGORY_ERROR:
      return { ...state, categoryInProgress: false, categoryError: payload };

    case WORKSHOP_PRODUCT_REQUEST:
      return { ...state, productInProgress: true, productError: null, currentProduct: null, relatedProducts: [] };
    case WORKSHOP_PRODUCT_SUCCESS:
      return {
        ...state,
        productInProgress: false,
        currentProduct: payload.product || null,
        relatedProducts: payload.related || [],
      };
    case WORKSHOP_PRODUCT_ERROR:
      return { ...state, productInProgress: false, productError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //
export const workshopHomeRequest = () => ({ type: WORKSHOP_HOME_REQUEST });
export const workshopHomeSuccess = data => ({ type: WORKSHOP_HOME_SUCCESS, payload: data });
export const workshopHomeError = e => ({ type: WORKSHOP_HOME_ERROR, payload: e });

export const workshopTypeRequest = () => ({ type: WORKSHOP_TYPE_REQUEST });
export const workshopTypeSuccess = data => ({ type: WORKSHOP_TYPE_SUCCESS, payload: data });
export const workshopTypeError = e => ({ type: WORKSHOP_TYPE_ERROR, payload: e });

export const workshopCategoryRequest = () => ({ type: WORKSHOP_CATEGORY_REQUEST });
export const workshopCategorySuccess = data => ({ type: WORKSHOP_CATEGORY_SUCCESS, payload: data });
export const workshopCategoryError = e => ({ type: WORKSHOP_CATEGORY_ERROR, payload: e });

export const workshopProductRequest = () => ({ type: WORKSHOP_PRODUCT_REQUEST });
export const workshopProductSuccess = data => ({ type: WORKSHOP_PRODUCT_SUCCESS, payload: data });
export const workshopProductError = e => ({ type: WORKSHOP_PRODUCT_ERROR, payload: e });

// ================ Thunks ================ //
export const loadWorkshopHome = () => dispatch => {
  dispatch(workshopHomeRequest());
  return fetchWorkshopHome({})
    .then(resp => {
      dispatch(workshopHomeSuccess(resp || {}));
      return resp;
    })
    .catch(e => {
      dispatch(workshopHomeError(e && e.message ? e.message : true));
    });
};

export const loadWorkshopType = slug => dispatch => {
  dispatch(workshopTypeRequest());
  return fetchWorkshopType({ slug })
    .then(resp => {
      dispatch(workshopTypeSuccess(resp || {}));
      return resp;
    })
    .catch(e => {
      dispatch(workshopTypeError(e && e.message ? e.message : true));
    });
};

export const loadWorkshopCategory = slug => dispatch => {
  dispatch(workshopCategoryRequest());
  return fetchWorkshopCategory({ slug })
    .then(resp => {
      dispatch(workshopCategorySuccess(resp || {}));
      return resp;
    })
    .catch(e => {
      dispatch(workshopCategoryError(e && e.message ? e.message : true));
    });
};

export const loadWorkshopProduct = slug => dispatch => {
  dispatch(workshopProductRequest());
  return fetchWorkshopProduct({ slug })
    .then(resp => {
      dispatch(workshopProductSuccess(resp || {}));
      return resp;
    })
    .catch(e => {
      dispatch(workshopProductError(e && e.message ? e.message : true));
    });
};
